import * as React from "react";
const SvgListLine = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M3 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2M3 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2M4 18a1 1 0 1 1-2 0 1 1 0 0 1 2 0M21 5a1 1 0 1 1 0 2H7a1 1 0 0 1 0-2zM22 12a1 1 0 0 0-1-1H7a1 1 0 1 0 0 2h14a1 1 0 0 0 1-1M22 18a1 1 0 0 0-1-1H7a1 1 0 1 0 0 2h14a1 1 0 0 0 1-1" }));
export default SvgListLine;
